var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineAdvantages7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2320,
    height: 84,
    viewBox: "0 0 2320 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3052_1064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2280.5 31.9609C2280.5 36.3792 2284.08 39.9609 2288.5 39.9609C2292.92 39.9609 2296.5 36.3792 2296.5 31.9609C2296.5 27.5426 2292.92 23.9609 2288.5 23.9609C2284.08 23.9609 2280.5 27.5426 2280.5 31.9609Z",
    fill: "#D71C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2258.5 31.9571C2258.5 48.5256 2271.93 61.9571 2288.5 61.9571C2305.07 61.9571 2318.5 48.5256 2318.5 31.9571C2318.5 15.3885 2305.07 1.95703 2288.5 1.95703C2271.93 1.95703 2258.5 15.3885 2258.5 31.9571Z",
    stroke: "#71253C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.720703 81.9609H1695.5H1739.5H2133.5L2191 31.9609H2258.5",
    stroke: "url(#paint0_linear_3052_1064)",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3052_1064",
    x1: 2285,
    y1: 75.9609,
    x2: 1618,
    y2: 75.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71253C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#3D2839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#010D2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3052_1064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2320,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAdvantages7);
export default __webpack_public_path__ + "static/media/line-Advantages7.591551137511322a603f8bc006323902.svg";
export { ForwardRef as ReactComponent };